var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAEFF6"
    },
    d: "M347.119,60.746c28.759-0.035,52.094,23.257,52.129,52.007c0.026,22.511-14.423,42.487-35.814,49.525 v-23.431L337.399,86.78l0.607-25.166C341.009,61.015,344.064,60.728,347.119,60.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5D0C7"
    },
    d: "M337.399,125.831c0-7.185-5.832-13.017-13.017-13.017c-7.185,0-13.017,5.832-13.017,13.017 c0,7.185,5.832,13.017,13.017,13.017C331.568,138.847,337.399,133.016,337.399,125.831z M337.399,86.78l26.034,52.068v23.431 c-5.276,1.701-10.778,2.577-16.315,2.603c-3.202,0.017-6.396-0.269-9.546-0.868c-28.255-5.346-46.826-32.586-41.481-60.841 c4.009-21.2,20.68-37.732,41.915-41.559L337.399,86.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M329.155,216.949c-4.53,26.303-25.218,46.844-51.547,51.2c-3.35,0.599-6.751,0.885-10.153,0.868 h-50.506l16.315-104.136h104.136l-8.07,51.113C329.242,216.342,329.242,216.602,329.155,216.949z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5D0C7"
    },
    d: "M182.237,112.814v52.068h-8.678c-14.379,0-26.034-11.655-26.034-26.034s11.655-26.034,26.034-26.034 H182.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5D0C7"
    },
    d: "M256,138.847c7.185,0,13.017-5.832,13.017-13.017c0-7.185-5.832-13.017-13.017-13.017 c-7.185,0-13.017,5.832-13.017,13.017C242.983,133.016,248.815,138.847,256,138.847z M337.399,164.881H233.264l-16.315,104.136 h43.39l-43.39,34.712l-43.39-34.712l8.678-104.136V95.458c37.923-0.59,68.365-31.492,68.382-69.424V0 c-0.035,28.715,23.214,52.033,51.929,52.068c0.017,0,0.035,0,0.052,0h35.666l-0.26,9.546 c-28.299,5.103-47.104,32.187-41.993,60.485c3.836,21.235,20.359,37.905,41.559,41.915L337.399,164.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5D0C7"
    },
    d: "M416.542,295.051v17.356h-52.068v-43.39c0-14.379,11.654-26.034,26.034-26.034v-43.39h26.034 c14.379,0,26.034,11.655,26.034,26.034v43.39C442.576,283.396,430.922,295.051,416.542,295.051z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5B05C"
    },
    d: "M338.267,52.068h-35.666c-28.715-0.009-51.99-23.3-51.981-52.016c0-0.017,0-0.035,0-0.052h43.39 c24.073,0.017,43.685,19.326,44.084,43.39L338.267,52.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5B05C"
    },
    d: "M250.62,0v26.034c-0.017,37.931-30.46,68.834-68.382,69.424h-1.041V43.39 c0-23.96,19.43-43.39,43.39-43.39H250.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00448F"
    },
    points: "245.153,327.159 242.983,329.763 225.627,347.119 216.949,355.797 208.271,347.119  190.915,329.763 188.746,327.159 216.949,303.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00448F"
    },
    points: "225.627,347.119 242.983,512 190.915,512 208.271,347.119 216.949,355.797  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3D3D3"
    },
    points: "164.881,399.186 164.881,512 112.814,425.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3D3D3"
    },
    points: "164.881,347.119 164.881,399.186 112.814,373.153 138.847,269.017 164.881,269.017  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3F3F3"
    },
    points: "208.271,347.119 190.915,512 164.881,512 164.881,399.186 164.881,347.119 188.746,327.159  190.915,329.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3F3F3"
    },
    points: "112.814,425.22 164.881,512 112.814,512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3F3F3"
    },
    points: "164.881,399.186 112.814,425.22 112.814,373.153  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M138.847,269.017l-26.034,104.136V512h-43.39V338.441 C69.424,300.101,100.508,269.017,138.847,269.017z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3D3D3"
    },
    points: "173.559,269.017 216.949,303.729 188.746,327.159 164.881,347.119 164.881,269.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3D3D3"
    },
    points: "321.085,425.22 269.017,512 269.017,399.186  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M307.287,269.191c32.126,1.796,57.24,28.394,57.188,60.572V512h-43.39V373.153l-43.39-104.136 l-0.087-0.868c11.307-1.822,21.877-6.751,30.546-14.232L307.287,269.191z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3F3F3"
    },
    points: "321.085,373.153 321.085,425.22 269.017,399.186  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3F3F3"
    },
    points: "269.017,399.186 269.017,512 242.983,512 225.627,347.119 242.983,329.763 245.153,327.159  269.017,347.119  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3D3D3"
    },
    d: "M267.455,269.017c3.402,0.017,6.804-0.269,10.153-0.868l0.087,0.868l43.39,104.136l-52.068,26.034 v-52.068l-23.864-19.959l-28.203-23.431l43.39-34.712H267.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M364.475,347.119v-34.712h52.068v147.525c0,28.759-23.309,52.068-52.068,52.068l0,0V347.119z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#454545"
    },
    cx: 324.382,
    cy: 125.831,
    r: 13.017
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#454545"
    },
    cx: 256,
    cy: 125.831,
    r: 13.017
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.475,
    y: 338.441,
    style: {
      fill: "#454545"
    },
    width: 26.034,
    height: 17.356
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.136,
    y: 373.153,
    style: {
      fill: "#E5E5E5"
    },
    width: 17.356,
    height: 138.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.407,
    y: 373.153,
    style: {
      fill: "#E5E5E5"
    },
    width: 17.356,
    height: 138.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.797,
    y: 329.763,
    style: {
      fill: "#E5E5E5"
    },
    width: 17.356,
    height: 182.237
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M329.763,225.627H314.49c-15.238,0.095-29.184-8.522-35.927-22.181l15.551-7.706 c3.836,7.732,11.75,12.592,20.376,12.531h14.666L329.763,225.627z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.173,
    y: 160.151,
    transform: "matrix(-0.9104 0.4138 -0.4138 -0.9104 842.2717 242.6984)",
    style: {
      fill: "#454545"
    },
    width: 17.356,
    height: 104.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M347.119,173.559c-3.749,0.026-7.498-0.321-11.186-1.024c-32.959-6.248-54.619-38.036-48.371-70.994 c4.686-24.697,24.099-43.963,48.84-48.458c3.532-0.694,7.116-1.041,10.717-1.015c33.549-0.017,60.763,27.162,60.78,60.711 c0.017,26.242-16.827,49.534-41.75,57.735C359.997,172.501,353.584,173.533,347.119,173.559z M347.119,69.424 c-2.473-0.017-4.946,0.208-7.376,0.686l-0.243,0.052c-23.578,4.278-39.224,26.867-34.938,50.445 c3.211,17.668,16.965,31.536,34.608,34.877c7.229,1.302,14.657,0.798,21.643-1.475c22.754-7.524,35.094-32.074,27.57-54.819 C382.499,81.399,365.854,69.398,347.119,69.424z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.58065d00.svg";
export { ForwardRef as ReactComponent };